import React from "react";

function Tick() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27.33"
      height="27.33"
      viewBox="0 0 27.33 27.33"
    >
      <path
        id="Path_19903"
        data-name="Path 19903"
        d="M15.665,29.33A13.665,13.665,0,1,0,2,15.665,13.665,13.665,0,0,0,15.665,29.33Zm7.457-17.14L14.3,21.014,8.549,15.265l1.933-1.932L14.3,17.149l6.891-6.891Z"
        transform="translate(-2 -2)"
        fill="#03f"
      />
    </svg>
  );
}

export default Tick;
